const getTaskType = ({ type, target }) =>
  type ? type : target ? 'repeating' : 'single'

export { getTaskType }
